<!-- eslint-disable vue/attributes-order -->
<template>
	<div class="container-fluid">
		<div class="row mb-5">
			<div class="col-12">
				<ul id="masterInfoAssets" class="nav nav-tabs" role="tablist">
					<li class="nav-item" role="presentation">
						<button id="interest-tab" class="nav-link active" data-bs-toggle="tab"
							data-bs-target="#interestTab" type="button" role="tab" aria-controls="interestTab"
							aria-selected="true" @click="onClickTab('1')">
							{{ $t("content.amninterest") }}
						</button>
					</li>

					<li class="nav-item" role="presentation">
						<button id="promo-tab" class="nav-link" data-bs-toggle="tab" data-bs-target="#promoTab"
							type="button" role="tab" aria-controls="promoTab" aria-selected="false"
							@click="onClickTab('2')">
							{{ $t("content.promo") }}
						</button>
					</li>
				</ul>

				<div id="interestContent" class="tab-content">
					<div id="interestTab" class="tab-pane fade show active" role="tabpanel"
						aria-labelledby="interest-tab">

						<div class="card h-100 mt-2">

							<div class="card-header d-flex justify-content-between align-items-center mb-0">
								<h5 style="display: inline-block;">{{ $t("content.amninterest") }}</h5>
								<material-button color="primary" variant="outline" class="btn ms-1"
									@click="addItemInterest">
									<i class="material-icons material-symbols-outlined">add</i>
									{{ add }}
								</material-button>

								<material-button color="primary" variant="outline" class="btn ms-1" v-show="false"
									data-bs-toggle="modal" data-bs-target="#newInterestListModal" id="newInterest">
								</material-button>

							</div>

							<div class="card-body pt-0">
								<div class="row mt-1">
									<div class="col-lg-3">
										<label class="form-label ms-0">{{ $t("content.inttypes") }}</label>
										<select class="form-select" v-model="search_int">
											<option value="">{{ $t('content.optall') }}</option>
											<option v-for="(item, index) in forms.listType" :value="item.val"
												:key="index">
												{{ item.items }}
											</option>
										</select>
									</div>

									<div class="col-lg-3">
										<label class="form-label ms-0">{{ $t("content.status") }}</label>
										<select class="form-select" v-model="search_status">
											<option value="">{{ $t('content.optall') }}</option>
											<option v-for="(item, index) in forms.listStatus" :value="item.val"
												:key="index">
												{{ item.val }}
											</option>
										</select>
									</div>

									<div class="col-lg-3">
										<label class="form-label ms-0"> {{ $t("content.amnpastsearch") }}</label>
										<select class="form-select" v-model="selectm_i">
										    <option value="">{{ $t('content.currently') }}</option>
											<option value="all">{{ $t('content.optall') }}</option>
											<option value="6">6 {{ $t('content.months') }}</option>
											<option value="12">12 {{ $t('content.months') }}</option>
										</select>
									</div>





									<div class="col-lg-2">
										<label class="form-label ms-0 png"></label>
										<material-button color="primary" class="float-lg-start float-sm-end mb-3"
											@click="loadInterestListApi">
											<i class="material-icons material-symbols-outlined">search</i> {{ btnSearch
											}}
										</material-button>
									</div>
								</div>
								<div class="row">
									<div class="table-responsive">
										<table class="table table-flush">
											<thead class="thead-light">
												<tr>
													<th>#</th>
													<th>{{ $t("content.cdefault") }}</th>
													<th>{{ $t("content.listname") }}</th>
													<th>{{ $t("content.inttypes") }}</th>
													<th>{{ $t("content.startprice") }}</th>
													<th>{{ $t("content.endprice") }}</th>
													<th>{{ $t("content.cintrate") }}</th>
													<th>{{ $t("content.sdate") }}</th>
													<th>{{ $t("content.edate") }}</th>
													<th>{{ $t("content.status") }}</th>
													<th>{{ $t("content.act") }}</th>
												</tr>
											</thead>
											<tbody v-for="(row, index) in listinterest" :key="index"
												:data-group-index="index">
												<tr class="group-id-ticket" :class="row.intStatus === 'APPROVE' ? '' : 'bg-working'">
													<td class="text-sm font-weight-normal"> {{ formatNumberString((currentPageI - 1) * perPageI + index + 1) }}</td>
													<td class="text-sm font-weight-normal">
														<material-checkbox :checked="row.defaultInt" disabled />
													</td>
													<td class="text-sm font-weight-normal">{{ row.intName }}</td>
													<td class="text-sm font-weight-normal">{{ checkIntType(row.intType)
														}}
													</td>
													<td class="text-sm font-weight-normal"></td>
													<td class="text-sm font-weight-normal"></td>
													<td class="text-sm font-weight-normal"></td>

													<td class=" text-sm font-weight-normal">
														{{ format_date(row.startDate) }}</td>
													<td class=" text-sm font-weight-normal">
														{{ format_date(row.endDate) }}</td>
													<td class=" text-sm font-weight-normal">
														{{ row.intStatus }}</td>
													<td class="text-sm font-weight-normal">

														<material-button color="danger" variant="outline"
															class="rounded-circle" data-bs-toggle="tooltip"
															data-bs-placement="top" :title="terminate"
															@click="updateItemsInterest(row, 'terminate')"
															:disabled="row.intStatus !== 'APPROVE' || new Date(row.endDate) < new Date()">
															<i
																class="material-icons material-symbols-outlined">close</i>
														</material-button>
														<material-button color="warning" variant="outline"
															class="rounded-circle" data-bs-toggle="tooltip"
															data-bs-placement="top" :title="approve + '/' + revert"
															@click="updateItemsInterest(row, 'approve')"
															:disabled="(row.intStatus !== 'APPROVE' && row.intStatus !== 'DRAFT') || new Date(row.endDate) < new Date() || row.tiers.filter(item => item.uid !== '0').length === 0">
															<i
																class="material-icons material-symbols-outlined">done_all</i>
														</material-button>
														<material-button color="primary" variant="outline"
															class="rounded-circle" data-bs-toggle="tooltip"
															data-bs-placement="top" :title="btnEdit"
															@click="editItemInterest(row)"
															:disabled="row.intStatus === 'APPROVE'">
															<i class="material-icons material-symbols-outlined">edit</i>
														</material-button>
														<material-button color="danger" variant="outline"
															class="rounded-circle" data-bs-toggle="tooltip"
															data-bs-placement="top" :title="btnDel"
															@click="deleteRowInterestItems(row)"
															:disabled="row.intStatus === 'APPROVE'">
															<i
																class="material-icons material-symbols-outlined">delete</i>
														</material-button>
													</td>
												</tr>
												<tr v-for="(j, set1) in row.tiers" :key="set1">
													<td class="text-sm font-weight-normal">
													</td>
													<td class="text-sm font-weight-normal"></td>
													<td class="text-sm font-weight-normal"></td>
													<td class="text-sm font-weight-normal"></td>
													<td v-if="j.uid !== '0' && j.uid !== tier_detail.uid"
														class="text-sm font-weight-normal text-end">
														{{ numberWithCommas(j.startValue) }}</td>
													<td v-if="j.uid !== '0' && j.uid !== tier_detail.uid"
														class="text-sm font-weight-normal text-end">
														{{ numberWithCommas(j.endValue) }}</td>
													<td v-if="j.uid !== '0' && j.uid !== tier_detail.uid"
														class="text-sm font-weight-normal text-end">
														{{ formatNumberString(j.rate) }}
													</td>
													<td v-if="j.uid !== '0' && j.uid !== tier_detail.uid"
														class="text-sm font-weight-normal">
														<material-button color="info" variant="outline"
															class="rounded-circle" data-bs-toggle="tooltip"
															data-bs-placement="top" :title="btnEdit"
															v-if="set1 + 1 === Number(row.tiers.length - 1) && row.intStatus === 'DRAFT'"
															@click="editRowItemsTiers(j)">
															<i class="material-icons material-symbols-outlined">edit</i>
														</material-button>
														<material-button color="danger" variant="outline"
															class="rounded-circle" data-bs-toggle="tooltip"
															data-bs-placement="top" :title="btnDel"
															v-if="set1 + 1 === Number(row.tiers.length - 1) && set1 + 1 !== 1 && row.intStatus === 'DRAFT'"
															@click="deleteRowItemsTiers(j, row)">
															<i
																class="material-icons material-symbols-outlined">delete</i>
														</material-button>
													</td>
													<td v-if="j.uid !== '0' && j.uid === tier_detail.uid"
														class="text-sm font-weight-normal text-end">
														<InputNumber v-model="tier_detail.startValue" autocomplete="off"
															@focus="$event.target.select()" disabled />
													</td>
													<td v-if="j.uid !== '0' && j.uid === tier_detail.uid"
														class="text-sm font-weight-normal text-end">
														<InputNumber v-model="tier_detail.endValue" autocomplete="off"
															@focus="$event.target.select()" />
													</td>
													<td v-if="j.uid !== '0' && j.uid === tier_detail.uid"
														class="text-sm font-weight-normal text-end">
														<InputNumber v-model="tier_detail.rate" :minFractionDigits="0"
															:maxFractionDigits="2" autocomplete="off"
															@focus="$event.target.select()" />
													</td>
													<td v-if="j.uid !== '0' && j.uid === tier_detail.uid"
														class="text-sm font-weight-normal">

														<material-button color="primary" variant="outline"
															class="rounded-circle" data-bs-toggle="tooltip"
															data-bs-placement="top" :title="btnSave" :disabled="tier_detail.startValue === '' || tier_detail.startValue === null || tier_detail.startValue <= start_limit || parseFloat(tier_detail.startValue) === 0 ||
																tier_detail.endValue === '' || tier_detail.endValue === null || tier_detail.endValue <= tier_detail.startValue || parseFloat(tier_detail.endValue) === 0 ||
																tier_detail.rate === '' || tier_detail.rate === null || parseFloat(tier_detail.rate) === 0"
															@click="saveEditRowItemsInterestTier(row,j)">
															<i class="material-icons material-symbols-outlined">save</i>
														</material-button>
														<material-button color="danger" variant="outline"
															class="rounded-circle" data-bs-toggle="tooltip"
															data-bs-placement="top" :title="btnClose"
															@click="cancelEditRowItems">
															<i
																class="material-icons material-symbols-outlined">close</i>
														</material-button>
													</td>
													<td v-if="j.uid === '0'"
														class="text-sm font-weight-normal text-end">
														<InputNumber v-model="j.startValue" autocomplete="off"
															@focus="$event.target.select()" disabled />
													</td>
													<td v-if="j.uid === '0'"
														class="text-sm font-weight-normal text-end">
														<InputNumber v-model="j.endValue" autocomplete="off"
															@focus="$event.target.select()" />
													</td>
													<td v-if="j.uid === '0'"
														class="text-sm font-weight-normal text-end">
														<InputNumber v-model="j.rate" :minFractionDigits="0"
															:maxFractionDigits="2" autocomplete="off"
															@focus="$event.target.select()" />
													</td>
													<td v-if="j.uid === '0'" class="text-sm font-weight-normal">
														<material-button color="primary" variant="outline"
															class="rounded-circle" data-bs-toggle="tooltip"
															data-bs-placement="top" :title="intrate"
															v-if="set1 + 1 === row.tiers.length && row.intStatus === 'DRAFT'"
															:disabled="j.startValue === '' || j.startValue === null || j.startValue <= start_limit || parseFloat(j.startValue) === 0 ||
																j.endValue === '' || j.endValue === null || j.endValue <= j.startValue || parseFloat(j.endValue) === 0 ||
																j.rate === '' || j.rate === null || parseFloat(j.rate) === 0 || tier_detail.uid !== ''"
															@click="addNewItemsInterestTier(row)">
															<i
																class="material-icons material-symbols-outlined">playlist_add</i>
														</material-button>

													</td>
													<td class="text-sm font-weight-normal"></td>
													<td class="text-sm font-weight-normal"></td>
												</tr>
											</tbody>
											<tbody v-if="listinterest.length === 0">
												<tr v-if="listinterest.length === 0">
													<td colspan="10" class="text-sm font-weight-normal">
														<p style="text-align: center">No Record Found</p>
													</td>
												</tr>
											</tbody>
											<tfoot>
												<tr>
													<td colspan="11" style="text-align: right">Total Rows : {{
														totalRows_sI }}</td>
												</tr>
											</tfoot>

										</table>
									</div>
								</div>
								<pre></pre>
								<div style="display: flex; justify-content: flex-end">
									<ul v-show="listinterest.length > 0" class="">
										<div class="project-container">
											<div class="example-one">
												<vue-awesome-paginate v-model="currentPageI" :total-items="totalRowsI"
													:items-per-page="perPageI" @click="onClickHandlerI" />
											</div>
										</div>
									</ul>
								</div>
							</div>

						</div>

					</div>

					<div id="promoTab" class="tab-pane fade" role="tabpanel" aria-labelledby="promo-tab">
						<div class="card h-100 mt-2">
							<div class="card-header d-flex justify-content-between align-items-center mb-0">
								<h5 style="display: inline-block;">{{ $t("content.promo") }}</h5>
								<material-button color="primary" variant="outline" class="btn ms-1"
									data-bs-toggle="modal" data-bs-target="#newPromoListModal" id="newPromo"
									v-show="false">

								</material-button>
								<material-button color="primary" variant="outline" class="btn ms-1"
									@click="addItemPromotion">
									<i class="material-icons material-symbols-outlined">add</i>
									{{ add }}
								</material-button>
							</div>
							<div class="card-body pt-0">
								<div class="row mt-1">
									<div class="col-lg-3">
										<label class="form-label ms-0">{{ $t('content.amntypecustomer')
											}}</label>
										<select class="form-select" v-model="search_custp">
											<option value="">{{ $t('content.optall') }}</option>
											<option v-for="(item, index) in listcustype" :value="item.uid" :key="index">
												{{ item.name }}
											</option>
										</select>
									</div>

									<div class="col-lg-3">
										<label class="form-label ms-0">{{ $t("content.status") }}</label>
										<select class="form-select" v-model="search_statusp">
											<option value="">{{ $t('content.optall') }}</option>
											<option v-for="(item, index) in forms.listStatus" :value="item.val"
												:key="index">
												{{ item.val }}
											</option>
										</select>
									</div>

									<div class="col-lg-3">
										<label class="form-label ms-0"> {{ $t("content.amnpastsearch") }}</label>
										<select class="form-select" v-model="selectm_p">
										    <option value="">{{ $t('content.currently') }}</option>
											<option value="all">{{ $t('content.optall') }}</option>
											<option value="6">6 {{ $t('content.months') }}</option>
											<option value="12">12 {{ $t('content.months') }}</option>
										</select>
									</div>

									<div class="col-lg-2">
										<label class="form-label ms-0 png"></label>
										<material-button color="primary" class="float-lg-start float-sm-end mb-3"
											@click="loadPromotionListApi">
											<i class="material-icons material-symbols-outlined">search</i> {{ btnSearch
											}}
										</material-button>
									</div>
								</div>
								<div class="row">
									<div class="table-responsive">
										<table class="table table-flush">
											<thead class="thead-light">
												<tr>
													<th>#</th>
													<th>{{ $t("content.listname") }}</th>
													<th>{{ $t("content.cgrade") }}</th>
													<th>{{ $t("content.detail") }}</th>
													<th>{{ $t("content.startprice") }}</th>
													<th>{{ $t("content.endprice") }}</th>
													<th>{{ $t("content.cintrate") }}</th>
													<th>{{ $t("content.sdate") }}</th>
													<th>{{ $t("content.edate") }}</th>
													<th>{{ $t("content.status") }}</th>
													<th>{{ $t("content.act") }}</th>
												</tr>
											</thead>
											<tbody :data-group-index="index" >
												<template v-for="(item, index) in listpromotion" :key="item.uid"
												>
													<!-- 1. แถวหลักของโปรโมชั่น (สีเขียวเข้ม/อ่อนตามรูป) -->
													<tr class="group-id-ticket" :class="item.intStatus === 'APPROVE' ? '' : 'bg-working'">
														<td class="text-sm font-weight-normal">{{ formatNumberString((currentPageP - 1) * perPageP + index + 1) }}</td> <!-- ลำดับรายการหลัก -->
														<td class="text-sm font-weight-normal">{{ item.promoName }}</td>
														<td class="text-sm font-weight-normal">{{ checkCustype(item.cusTypeUid) }}</td>
														<td class="text-sm font-weight-normal" colspan="4">{{ item.description }}</td>
														<td class="text-sm font-weight-normal">{{ format_date(item.startDate) }}</td>
														<td class="text-sm font-weight-normal">{{ format_date(item.endDate) }}</td>
														<td class=" text-sm font-weight-normal">{{ item.intStatus }}</td>
													    <td class="text-sm font-weight-normal">

														<material-button color="danger" variant="outline"
															class="rounded-circle" data-bs-toggle="tooltip"
															data-bs-placement="top" :title="terminate"
															@click="updateItemsPromotion(item, 'terminate')"
															:disabled="item.intStatus !== 'APPROVE' || new Date(item.endDate) < new Date()">
															<i
																class="material-icons material-symbols-outlined">close</i>
														</material-button>
														<material-button color="warning" variant="outline"
															class="rounded-circle" data-bs-toggle="tooltip"
															data-bs-placement="top" :title="approve + '/' + revert"
															@click="updateItemsPromotion(item, 'approve')"
															:disabled="(item.intStatus !== 'APPROVE' && item.intStatus !== 'DRAFT') || new Date(item.endDate) < new Date()">
															<i
																class="material-icons material-symbols-outlined">done_all</i>
														</material-button>
														<material-button color="primary" variant="outline"
															class="rounded-circle" data-bs-toggle="tooltip"
															data-bs-placement="top" :title="btnEdit"
															@click="editItemPromotion(item)"
															:disabled="item.intStatus === 'APPROVE'">
															<i class="material-icons material-symbols-outlined">edit</i>
														</material-button>
														<material-button color="danger" variant="outline"
															class="rounded-circle" data-bs-toggle="tooltip"
															data-bs-placement="top" :title="btnDel"
															@click="deleteRowPromotionItems(item)"
															:disabled="item.intStatus === 'APPROVE'">
															<i
																class="material-icons material-symbols-outlined">delete</i>
														</material-button>
													</td>
													</tr>

													<!-- 2. วนลูปกลุ่มเดือน (Tiers Layer 1) -->
													<template v-for="(group, gIdx) in item.tiers" :key="'g-' + gIdx">
														
														<!-- วนลูปแถวราคา (Tiers Layer 2) -->
														<tr v-for="(sub, sIdx) in group.tiers" :key="'s-' + sIdx" class="sub-row">
														
														<!-- แสดงเลขลำดับกลุ่ม (Month Order) -->
														<td>
															<!-- แสดงเลขกลุ่ม (1, 2, 3...) เฉพาะแถวแรกของกลุ่มนั้นๆ เพื่อความสวยงาม -->
															<span v-if="sIdx === 0" style="color: blue;">
															ช่วงที่ {{ gIdx + 1 }}
															</span>
														</td>
														
														<td>
															<span v-if="sIdx === 0">
															ระยะเวลาของดอกเบี้ย {{ group.month }} เดือน
															</span>
														</td>

														<td colspan="2"></td> <!-- เว้นที่ว่างให้ตรงกับหัวข้อ -->
														
														<!-- ข้อมูลราคาและเรท -->
														<td class="text-sm font-weight-normal text-end">{{ sub.startValue.toLocaleString() }}</td>
														<td class="text-sm font-weight-normal text-end">{{ sub.endValue.toLocaleString() }}</td>
														<td class="text-sm font-weight-normal text-end">{{ sub.rate }}%</td>
														
														<td colspan="4"></td> <!-- ปิดท้ายแถวให้ครบคอลัมน์ -->
														</tr>
													</template>
													</template>
													</tbody>
														<tbody v-if="listpromotion.length === 0">
															<tr v-if="listpromotion.length === 0">
																<td colspan="10" class="text-sm font-weight-normal">
																	<p style="text-align: center">No Record Found</p>
																</td>
															</tr>
														</tbody>
														<tfoot>
															<tr>
																<td colspan="11" style="text-align: right">Total Rows : {{
																	totalRows_sP }}</td>
															</tr>
														</tfoot>

											</table>
									</div>
								</div>
								<pre></pre>
								<div style="display: flex; justify-content: flex-end">
									<ul v-show="listpromotion.length > 0" class="pagination justify-content-end">
										<div class="project-container">
											<div class="example-one">
												<vue-awesome-paginate v-model="currentPageP" :total-items="totalRowsP"
													:items-per-page="perPageP" @click="onClickHandlerP" />
											</div>
										</div>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- Add New List Dialog -->
				<div id="newInterestListModal" class="modal fade" tabindex="-1"
					aria-labelledby="newInterestListModalLabel" aria-hidden="true">
					<div class="modal-dialog">
						<div class="modal-content">
							<div class="modal-header">
								<h4 class="modal-title">{{ title_interest }}</h4>
								<button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
									<i class="material-icons material-symbols-outlined">close</i>
								</button>
							</div>

							<div class="modal-body">
								<fieldset>
									<div class="row">
										<div class="col-lg-8">
											<label class="form-label ms-0 mb-0 me-3" for="listName">
												{{ $t("content.listname") }}
											</label>
											<material-input id="listName" v-model="interest_detail.intName"
												type="text" />
										</div>

										<div class="col-lg-3">
											<label class="form-label ms-0 mb-0 me-3" for="listType">
												{{ $t("content.inttypes") }}
											</label>
											<select id="listType" class="form-select" v-model="interest_detail.intType">
												<option value="" disabled selected>{{ $t('content.select') }}</option>
												<option v-for="(a, sel1) in forms.listType" :key="sel1" :value="a.val">
													{{ a.items }}
												</option>
											</select>
										</div>

										<div class="col-lg-1">
											<label class="form-label ms-0">
												{{ $t("content.cdefault") }}
											</label>
											<material-checkbox id="listDefault" :checked="interest_detail.defaultInt"
												v-model="interest_detail.defaultInt"
												style="margin-top: 0px !important; text-align: center !important;" />
										</div>
										<div class="col-12">
											<label class="form-label ms-0 mb-0 me-3" for="promoDetail">
												{{ $t("content.detail") }}
											</label>
											<Textarea rows="3" v-model="interest_detail.description" class="w-100"
												autocomplete="off" />
										</div>
										<div class="col-lg-6">
											<label class="form-label ms-0 mb-0 me-3" for="listStartDate">
												{{ $t("content.sdate") }}
											</label>
											<VueDatePicker v-model="interest_detail.startDate" :format="format"
												auto-apply :teleport="true" :enable-time-picker="false"
												month-name-format="long" :clearable="false"
												:text-input="textInputOptions" fluid />
										</div>

										<div class="col-lg-6">
											<label class="form-label ms-0 mb-0 me-3" for="listEndDate">
												{{ $t("content.edate") }}
											</label>
											<VueDatePicker v-model="interest_detail.endDate" :format="format" auto-apply
												:teleport="true" :enable-time-picker="false" month-name-format="long"
												:clearable="false" :text-input="textInputOptions" fluid />
										</div>
									</div>
								</fieldset>
							</div>

							<div class="modal-footer justify-content-between">
								<material-button color="error" variant="contained" class="btn btn-danger"
									data-bs-dismiss="modal">
									{{ cancel }}
								</material-button>
								<div class="d-flex justify-content-end align-items-center">
									<material-button color="primary" variant="contained" class="btn"
										data-bs-dismiss="modal" :disabled="interest_detail.intName.trim() === '' || interest_detail.intType === ''
											|| interest_detail.endDate < interest_detail.startDate" @click="chkProcessInterest">
										{{ save }}
									</material-button>

								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- Add New Promo List Dialog -->
				<div id="newPromoListModal" class="modal fade" tabindex="-1" aria-labelledby="newPromoListModalLabel"
					aria-hidden="true">
					<div class="modal-dialog">
						<div class="modal-content">
							<div class="modal-header">
								<h4 class="modal-title">{{ title_promotion }}</h4>
								<button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
									<i class="material-icons material-symbols-outlined">close</i>
								</button>
							</div>

							<div class="modal-body">
								<fieldset>
									<div class="row">
										<div class="col-lg-8">
											<label class="form-label ms-0 mb-0 me-3" for="promoName">
												{{ $t("content.listname") }}
											</label>
											<material-input id="listName" v-model="promotion_detail.promoName"
												type="text" />
											
										</div>

										<div class="col-lg-4">
											<label class="form-label ms-0 mb-0 me-3">{{ $t('content.amntypecustomer')
												}}</label>
											<select class="form-select" v-model="promotion_detail.cusTypeUid">
												<option value="" disabled selected>{{ $t('content.select') }}</option>
												<option v-for="(item, index) in listcustype" :value="item.uid"
													:key="index">
													{{ item.name }}
												</option>
											</select>
										</div>

										<div class="col-12">
											<label class="form-label ms-0 mb-0 me-3" for="promoDetail">
												{{ $t("content.detail") }}
											</label>
											<Textarea rows="3" v-model="promotion_detail.description" class="w-100"
												autocomplete="off" />
										</div>

										<div class="col-lg-6">
											<label class="form-label ms-0 mb-0 me-3" for="listStartDate">
												{{ $t("content.sdate") }}
											</label>
											<VueDatePicker v-model="promotion_detail.startDate" :format="format"
												auto-apply :teleport="true" :enable-time-picker="false"
												month-name-format="long" :clearable="false"
												:text-input="textInputOptions" fluid />
										</div>

										<div class="col-lg-6">
											<label class="form-label ms-0 mb-0 me-3" for="listEndDate">
												{{ $t("content.edate") }}
											</label>
											<VueDatePicker v-model="promotion_detail.endDate" :format="format"
												auto-apply :teleport="true" :enable-time-picker="false"
												month-name-format="long" :clearable="false"
												:text-input="textInputOptions" fluid />
										</div>
										<!-- Section: Dynamic Tiers -->
										<div class="col-12 mt-4">
											<div class="d-flex justify-content-between align-items-center mb-2">
												<label class="form-label fw-bold text-primary mb-0">เงื่อนไขโปรโมชั่น (Tiers)</label>
												<button type="button" class="btn btn-sm btn-outline-primary" @click="addTierGroup">
													+ เพิ่มชุดเงื่อนไข
												</button>
											</div>

											<!-- Loop ตาม Ordinal Groups -->
												<div v-for="(group, gIdx) in promotion_detail.tiers" :key="gIdx" class="border rounded p-3 mb-3 bg-light">
													
													<!-- ส่วนหัว (Badge และ Input เดือน) -->
													<div class="d-flex justify-content-between align-items-center mb-2">
														<span class="badge bg-secondary">ช่วงที่ {{ group.ordinal }}</span>
														<div class="d-flex align-items-center">
															<label class="me-2 mb-0 small">ระยะเวลา (เดือน):</label>
															<input 
																type="number" 
																v-model.number="group.month" 
																class="form-control form-control-sm" 
																style="width: 70px;" 
																min="1"
																@input="group.month = (group.month < 1 && group.month !== '') ? 1 : group.month"
																/>
															<button type="button" class="btn btn-link text-danger ms-2 p-0" @click="removeTierGroup(gIdx)">
																<i class="material-icons small">delete</i>
															</button>
														</div>
													</div>

													<!-- ส่วนแสดงตาราง Tiers: ลบ v-for ชั้นนี้ออกไปเลย! ใช้ div ธรรมดาพอ -->
													<div>
														<table class="table table-sm table-borderless mb-0">
															<thead>
																<tr class="small text-muted">
																	<th>{{ $t("content.startprice") }}</th>
																	<th>{{ $t("content.endprice") }}</th>
																	<th>{{ $t("content.cintrate") }}</th>
																</tr>
															</thead>
															<tbody>
																<!-- วนลูปแถว (Tiers) ภายในกลุ่มนั้นๆ -->
																<tr v-for="(tier, tIdx) in group.tiers" :key="tIdx">
																	<td>
																		<InputNumber v-model="tier.startValue" disabled />
																	</td>
																	<td>
																		<InputNumber v-model="tier.endValue" :disabled="tIdx !== group.tiers.length - 1" @focus="$event.target.select()"/>
																	</td>
																	<td>
																		<InputNumber v-model="tier.rate" :disabled="tIdx !== group.tiers.length - 1" 
																		:minFractionDigits="0" :maxFractionDigits="2" autocomplete="off"
																		@focus="$event.target.select()"/>
																	</td>
																</tr>
															</tbody>
														</table>

														<!-- ปุ่มจัดการท้ายตาราง -->
														<div class="d-flex justify-content-between align-items-center mt-2">
															<button type="button" class="btn btn-link btn-sm p-0 text-primary" 
																@click="addTierRow(gIdx)" :disabled="group.tiers[group.tiers.length - 1].endValue === '' 
																 	|| group.tiers[group.tiers.length - 1].endValue === 0 
																	|| group.tiers[group.tiers.length - 1].endValue === null 
																	|| group.tiers[group.tiers.length - 1].endValue < group.tiers[group.tiers.length - 1].startValue
																	|| group.tiers[group.tiers.length - 1].rate === '' 
																 	|| group.tiers[group.tiers.length - 1].rate === 0 
																	|| group.tiers[group.tiers.length - 1].rate === null">
																<i class="material-icons small">add_circle</i> เพิ่มช่วงราคา
															</button>
															<button type="button" class="btn btn-link btn-sm p-0 text-danger" 
																@click="removeLastTierRow(gIdx)" v-if="group.tiers.length > 1">
																<i class="material-icons small">remove_circle</i> ลบแถวล่าสุด
															</button>
														</div>
													</div>
												</div>
										</div>
									</div>
								</fieldset>
							</div>

							<div class="modal-footer justify-content-between">
								<material-button color="error" variant="contained" class="btn btn-danger"
									data-bs-dismiss="modal">
									{{ cancel }}
								</material-button>
								<div class="d-flex justify-content-end align-items-center">
									<material-button 
										color="primary" 
										variant="contained" 
										class="btn"
										data-bs-dismiss="modal"
										:disabled="
											promotion_detail.promoName === '' || 
											promotion_detail.cusTypeUid === '' || 
											promotion_detail.endDate < promotion_detail.startDate || 
											promotion_detail.tiers.length === 0 ||
											/* เช็คลึกลงไปในทุกชุดและทุกแถว */
											promotion_detail.tiers.some(g => 
												!g.month || g.month < 1 || 
												g.tiers.some(t => 
													t.endValue === null || t.endValue === '' || t.endValue === 0 ||
													t.startValue === null || t.startValue === '' || t.startValue === 0 ||
													t.rate === null || t.rate === '' || t.rate === 0 ||
													Number(t.endValue) <= Number(t.startValue)
												)
											)
										" 
										@click="chkProcessPromotion">
										{{ save }}
									</material-button>

								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import InputNumber from 'primevue/inputnumber';
import RadioButton from 'primevue/radiobutton';
import Textarea from 'primevue/textarea';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import ExampleFive from "@/examples/ExampleOne";
import { reactive, computed, onMounted, ref, inject } from "vue";
import { useI18n } from "vue-i18n";
import * as Choices from "choices.js";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";
import moment from 'moment'
import axios from "axios";
import * as st from "@/config/setting.js";

import { useInterestStore } from '@/stores/interest'
import { usePromotiontStore } from '@/stores/promotion'
import { useInteresTiertStore } from '@/stores/interesttier'
import { useCusTypeStore } from '@/stores/custype'


const storei = useInterestStore()
const storep = usePromotiontStore()
const storeit = useInteresTiertStore()
const storect = useCusTypeStore()

const shop_detail = ref({})
const interest_detail = ref({
	uid: '',
	groupUid: '',
	shopUid: '',
	intName: '',
	description: '',
	intType: '',
	defaultInt: false,
	startDate: new Date(),
	endDate: new Date(),
	tiers: [],
	intStatus: '',
	version: '',
})
const promotion_detail = ref({
	uid: '',
	groupUid: '',
	shopUid: '',
	promoName: '',
	cusTypeUid: '',
	description: '',
	startDate: new Date(),
	endDate: new Date(),
	tiers: [],
	intStatus: '',
	version: '',
})
const tier_detail = ref({
	uid: '',
	startValue: '',
	endValue: '',
	rate: '',
})
// const key = JSON.parse(localStorage.getItem("shop_seleted"));


const { t } = useI18n();
const swal = inject('$swal')

const fmNumber = (val) => {
	let num = Number(val).toFixed(2)
	return formatNumberString(num)
	// return Intl.NumberFormat("en-US");
};



const forms = reactive({
	listName: "",
	listType: [
		{ items: computed(() => t("content.normal")), val: 'NORMAL' },
		{ items: computed(() => t("content.special")), val: 'SPECIAL' },
	],
	listStatus: [
		{ val: 'DRAFT' },
		{ val: 'APPROVE' },
	],
	// listIntType: [
	// 	{ items: computed(() => t("content.normal")), val: 'NORMAL' },
	// 	{ items: computed(() => t("content.special")), val: 'SPECIAL' },
	// ],
	listDefault: false,
	listStartPrice: fmNumber(50000000.00),
	listEndedPrice: fmNumber(99999999.99),
	listStartDate: "",
	listEndDate: "",
	listInterest: fmNumber(1.99),
})

const datas = reactive({
	detail: "",
	startDate: "",
	endDate: "",
	duration: "",
	demo1: [
		{ items: "Default" },
		{ items: "VVIP" },
	],
	demo2: [
		{ items: "GENERAL" },
		{ items: "MEMBER" },
		{ items: "SERENADE" },
		{ items: "VVIP" },
	],
	demo3: [
		{ items: computed(() => t("content.amngold")) },
	],
});

const add = computed(() => t("buttons.addd"));
// const confirm = computed(() => t("buttons.conf"));
const intrate = computed(() => t("content.createintrate"));
const btnDel = computed(() => t("buttons.dele"));
const btnEdit = computed(() => t("buttons.edit"))
const cancel = computed(() => t("buttons.canc"));
// const preview = computed(() => t("content.file"));
const save = computed(() => t("buttons.save"));
const approve = computed(() => t("buttons.approve"));
const revert = computed(() => t("buttons.revert"));
const terminate = computed(() => t("buttons.terminate"));
const btnSearch = computed(() => t("buttons.sear"))


const listinterest = ref([]);
const listpromotion = ref([]);
const listinteresttier = ref([]);
const listcustype = ref([]);
const listinterestP = ref([]);
const listint_s = ref([]);
const listint_e = ref([]);



const currentPageI = ref(1);
const totalRowsI = ref(1);
const perPageI = ref(10);
const totalRows_sI = ref();

const currentPageP = ref(1);
const totalRowsP = ref(1);
const perPageP = ref(10);
const totalRows_sP = ref();

const search_int = ref('');
const search_status = ref('');



const search_intp = ref('');
const search_custp = ref('');
const search_statusp = ref('');
const start_limit = ref(0);


const title_interest = ref('');
const process_interest = ref('');

const title_promotion = ref('');
const process_promotion = ref('');

const search_start = ref(new Date());
const search_end = ref(new Date());

const selectm_i = ref('');
const selectm_p = ref('');


const format = (date) => {
	return moment(String(date)).local().format('DD/MM/YYYY');
}

const textInputOptions = {
	format: 'dd/MM/yyyy'
};

const onClickHandlerI = (page) => {
	// console.log('onClickHandler :' + page);
	updatePaginationInterestApi()
};

const onClickHandlerP = (page) => {
	// console.log('onClickHandler :' + page);
	updatePaginationPromotionApi()
};

const loadCusTypeListApi = async (val) => {
	let data = "";
	data = {
		index: 0,
		size: 100,
		name: "",
		shopUid: shop_detail.value.uid
	};
	const payload = data;
	// console.log("payload : " + JSON.stringify(payload));
	const response = await storect.custypeListFetch(payload);
	// console.log("loadCashAccDataApi : " + JSON.stringify(response.data));
	if (response) {
		if (response.status === 200) {
			if (response.data.rtnDesc === "success") {
				listcustype.value = response.data.data.list;
			}
		}
	}
}


const loadDataShop = async () => {
	if (localStorage.getItem("shop_seleted") !== null) {
		shop_detail.value = JSON.parse(localStorage.getItem("shop_seleted"));
		if (shop_detail.value !== null) {
			loadCusTypeListApi();
			loadInterestListApi();
		}
	}
};

loadDataShop();


async function loadInterestListApi(val) {
	currentPageI.value = 1
	if (currentPageI.value !== 1) {
		if (listinterest.value.length === 1 && val === 'del') {
			currentPageI.value = currentPageI.value - 1
		}
	}
	// if (search_int.value !== '' || search_status.value !== '' || selectm_i.value !== '' && val !== 'del') {
	// 	currentPageI.value = 1
	// }
	let sd = '';
	let ed = '';

	if (selectm_i.value !== '') {
		if (selectm_i.value !== 'all') { 
			sd = new Date();
			sd.setMonth(sd.getMonth() - Number(selectm_i.value));
			sd = moment(new Date(sd)).local().format('YYYY-MM-DD')
		}
		
	} else {
		sd = new Date();
		sd = moment(new Date(sd)).local().format('YYYY-MM-DD')
		ed = new Date();
		ed.setDate(ed.getDate() - Number(1));
		ed = moment(new Date(ed)).local().format('YYYY-MM-DD')

	}
	let data = "";
	data = {
		index: currentPageI.value - 1,
		size: perPageI.value,
		shopUid: shop_detail.value.uid,
		intType: search_int.value,
		intStatus: search_status.value,
		startDate: sd,
		endDate: ed,
		use:selectm_i.value
	};
	const payload = data;
	// console.log("payload : " + JSON.stringify(payload));
	const response = await storei.interestConfigListFetch(payload);
	// console.log("loadInterestListApi : " + JSON.stringify(response.data));
	if (response) {
		if (response.status === 200) {
			if (response.data.rtnDesc === "success") {
				let list = response.data.data.list;
				if (list.length > 0) { 
					for (let i = 0; i < list.length; i++) {
						if (list[i].tiers.length > 0) {
							list[i].tiers.forEach(function (obj) {
									obj.uid = String(Math.floor(Math.random() * 9000000000000) + 1000000000000)
						    });  
							if (list[i].intStatus === 'DRAFT') {
								// console.log('l2 ' + i + " : " + JSON.stringify(list[i]))
								let max = 1
								if (list[i].tiers.length > 0) {
									max = Math.max(...list[i].tiers.map(o => o.endValue), 0);
									max = Number(max + 1)
								}

								let obj =
								{
									"uid": "0",
									"intUid": list[i].uid,
									"startValue": max,
									"endValue": "999999999",
									"rate": "",
								}
								list[i].tiers.push(obj)

							}

						} else { 
							if (list[i].intStatus === 'DRAFT') {

								let max = 1
								let obj =
								{
									"uid": "0",
									"intUid": list[i].intUid,
									"startValue": max,
									"endValue": "999999999",
									"rate": "",
								}
								list[i].tiers.push(obj)
							}
						} 

					}
				}

				listinterest.value = list
				// console.log("loadInterestListApi : " + JSON.stringify(listinterest.value));
				totalRowsI.value = response.data.data.ext.total
				totalRows_sI.value = formatNumberString(totalRowsI.value)

			}
		}
	}
}






const loadPromotionListApi = async (val) => {
	currentPageP.value = 1
	if (currentPageP.value !== 1) {
		if (listpromotion.value.length === 1 && val === 'del') {
			currentPageP.value = currentPageP.value - 1
		}
	}

	// if (search_intp.value !== '' || search_statusp.value !== '' || search_custp.value !== '' && val !== 'del') {
	// 	currentPageP.value = 1
	// }
	let sd = '';
	let ed = '';
	if (selectm_p.value !== '') {
		if (selectm_p.value !== 'all') { 
			sd = new Date();
			sd.setMonth(sd.getMonth() - Number(selectm_p.value));
			sd = moment(new Date(sd)).local().format('YYYY-MM-DD')
		}
		
	} else {
		sd = new Date();
		sd = moment(new Date(sd)).local().format('YYYY-MM-DD')
		ed = new Date();
		ed.setDate(ed.getDate() - Number(1));
		ed = moment(new Date(ed)).local().format('YYYY-MM-DD')
	}

	let data = "";
	data = {
		index: currentPageP.value - 1,
		size: perPageP.value,
		shopUid: shop_detail.value.uid,
		promoName: '',
		intStatus: search_statusp.value,
		cusTypeUid: search_custp.value,
		startDate: sd,
		endDate: ed,
		use:selectm_p.value
	};
	const payload = data;
	// console.log("payload : " + JSON.stringify(payload));
	const response = await storep.promotionConfigListFetch(payload);
	// console.log("loadPromotionListApi : " + JSON.stringify(response.data));
	if (response) {
		if (response.status === 200) {
			if (response.data.rtnDesc === "success") {
				listpromotion.value = response.data.data.list;
				totalRowsP.value = response.data.data.ext.total
				totalRows_sP.value = formatNumberString(totalRowsP.value)
			}

		}

	}
}



const updatePaginationInterestApi = async (val) => {
	listinterest.value = []
	let sd = '';
	let ed = '';
	if (selectm_i.value !== '') {
		if (selectm_i.value !== 'all') { 
			sd = new Date();
			sd.setMonth(sd.getMonth() - Number(selectm_i.value));
			sd = moment(new Date(sd)).local().format('YYYY-MM-DD')
		}
		
	} else {
		sd = new Date();
		sd = moment(new Date(sd)).local().format('YYYY-MM-DD')
		ed = new Date();
		ed.setDate(ed.getDate() - Number(1));
		ed = moment(new Date(ed)).local().format('YYYY-MM-DD')

	}
	let data = "";
	data = {
		index: currentPageI.value - 1,
		size: perPageI.value,
		shopUid: shop_detail.value.uid,
		intType: search_int.value,
		intStatus: search_status.value,
		startDate: sd,
		endDate: ed,
		use:selectm_i.value
	};
	const payload = data;
	// console.log("payload : " + JSON.stringify(payload));
	const response = await storei.interestConfigListFetch(payload);
	// console.log("loadInterestListApi : " + JSON.stringify(response.data));
	if (response) {
		if (response.status === 200) {
			if (response.data.rtnDesc === "success") {
				let list = response.data.data.list;
				if (list.length > 0) { 
					for (let i = 0; i < list.length; i++) {
						if (list[i].tiers.length > 0) {
							list[i].tiers.forEach(function (obj) {
									obj.uid = String(Math.floor(Math.random() * 9000000000000) + 1000000000000)
						    });  
							if (list[i].intStatus === 'DRAFT') {
								// console.log('l2 ' + i + " : " + JSON.stringify(list[i]))
								let max = 1
								if (list[i].tiers.length > 0) {
									max = Math.max(...list[i].tiers.map(o => o.endValue), 0);
									max = Number(max + 1)
								}

								let obj =
								{
									"uid": "0",
									"intUid": list[i].uid,
									"startValue": max,
									"endValue": "999999999",
									"rate": "",
								}
								list[i].tiers.push(obj)

							}

						} else { 
							if (list[i].intStatus === 'DRAFT') {

								let max = 1
								let obj =
								{
									"uid": "0",
									"intUid": list[i].intUid,
									"startValue": max,
									"endValue": "999999999",
									"rate": "",
								}
								list[i].tiers.push(obj)
							}
						} 

					}
				}
				listinterest.value = list
				// console.log("loadInterestListApi : " + JSON.stringify(listinterest.value));
				totalRowsI.value = response.data.data.ext.total
				totalRows_sI.value = formatNumberString(totalRowsI.value)

			}
		}
	}
}

const updatePaginationPromotionApi = async (val) => {
	listpromotion.value = []
	let sd = '';
	let ed = '';
	if (selectm_p.value !== '') {
		if (selectm_p.value !== 'all') { 
			sd = new Date();
			sd.setMonth(sd.getMonth() - Number(selectm_p.value));
			sd = moment(new Date(sd)).local().format('YYYY-MM-DD')
		}
		
	} else {
		sd = new Date();
		sd = moment(new Date(sd)).local().format('YYYY-MM-DD')
		ed = new Date();
		ed.setDate(ed.getDate() - Number(1));
		ed = moment(new Date(ed)).local().format('YYYY-MM-DD')
	}

	let data = "";
	data = {
		index: currentPageP.value - 1,
		size: perPageP.value,
		shopUid: shop_detail.value.uid,
		promoName: '',
		intStatus: search_statusp.value,
		cusTypeUid: search_custp.value,
		startDate: sd,
		endDate: ed,
		use:selectm_p.value
	};
	const payload = data;
	console.log("payload : " + JSON.stringify(payload));
	const response = await storep.promotionConfigListFetch(payload);
	// console.log("loadPromotionListApi : " + JSON.stringify(response.data));
	if (response) {
		if (response.status === 200) {
			if (response.data.rtnDesc === "success") {
				listpromotion.value = response.data.data.list;
				totalRowsP.value = response.data.data.ext.total
				totalRows_sP.value = formatNumberString(totalRowsP.value)
			}

		}

	}
}


async function onClickTab(val) {
	if (val === '1') {
		await loadInterestListApi();
	} else if (val === '2') {
		await loadPromotionListApi();
	}
}

function formatNumberString(num) {
	return String(num).replace(
		/(\d)(?=(\d{3})+(?!\d))/g,
		"$1,"
	);
}

function numberWithCommas(x) {
	return Math.round(x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}



function format_date(value) {
	if (value) {
		return moment(String(value)).local().format('DD/MM/YYYY')
	}
}



function filterData(str, matchArr) {
	return matchArr.filter((c) => c.intUid === str);
}

function clearItemInterest() {
	datas.addNew = false
	interest_detail.value = {
		uid: '',
		groupUid: '',
		shopUid: '',
		intName: '',
		description: '',
		intType: '',
		defaultInt: false,
		startDate: new Date(),
		endDate: new Date(),
		tiers: [],
		intStatus: '',
		version: '',
	}

}

function addItemInterest() {
	clearItemInterest()
	title_interest.value = t("content.addinterest")
	process_interest.value = 'add'
	document.getElementById('newInterest').click()
}


function editItemInterest(item) {
	clearItemInterest()
	interest_detail.value = {
		uid: item.uid,
		groupUid:item.groupUid,
		shopUid: item.shopUid,
		intName: item.intName,
		description: item.description,
		intType: item.intType,
		defaultInt: item.defaultInt,
		startDate: new Date(item.startDate),
		endDate: new Date(item.endDate),
		tiers: item.tiers,
		intStatus: item.intStatus,
		version: item.version,
	}
	title_interest.value = t("content.editinterest")
	process_interest.value = 'edit'
	document.getElementById('newInterest').click()
}

function chkProcessInterest() {
	if (process_interest.value === 'add') {
		addInterest()
	} else if (process_interest.value === 'edit') {
		editInterest()
	}
}

async function addNewItemsInterestTier(item) {
	swal({
		title: "เพิ่มรายการ",
		text: "คุณต้องการเพิ่มรายการนี้ใช่ไหม",
		icon: "info",
		allowOutsideClick: false,
		showCloseButton: false,
		showCancelButton: true,
		closeOnConfirm: false,
		focusConfirm: false,
		animation: "slide-from-top",
		confirmButtonText: t('buttons.conf'),
		cancelButtonText: t('buttons.canc'),
	}).then((result) => {
		if (result.isConfirmed) {
			addInterestTier(item)
		}
	})
}

async function saveEditRowItemsInterestTier(row,item) {
	swal({
		title: "บันทึกแก้ไขรายการ",
		text: "คุณต้องการบันทึกแก้ไขรายการนี้ใช่ไหม",
		icon: "info",
		allowOutsideClick: false,
		showCloseButton: false,
		showCancelButton: true,
		closeOnConfirm: false,
		focusConfirm: false,
		animation: "slide-from-top",
		confirmButtonText: t('buttons.save'),
		cancelButtonText: t('buttons.canc'),
	}).then((result) => {
		if (result.isConfirmed) {
			if (row.uid !== "" && row.version !== "") {
				updateInterestTier(row,item)
			}
		}
	})
}


async function cancelEditRowItems() {
	swal({
		title: "ยกเลิกแก้ไขรายการ",
		text: "คุณต้องการยกเลิกแก้ไขรายการนี้ใช่ไหม",
		icon: "warning",
		allowOutsideClick: false,
		showCloseButton: false,
		showCancelButton: true,
		closeOnConfirm: false,
		focusConfirm: false,
		animation: "slide-from-top",
		confirmButtonText: t('buttons.conf'),
		cancelButtonText: t('buttons.canc'),
	}).then((result) => {
		if (result.isConfirmed) {
			datas.rowEdit = false
			cancelInterestTier()
		} else if (result.dismiss == 'cancel') {
			datas.rowEdit = true
		}
	})
}

function cancelInterestTier() {
	tier_detail.value = {
		uid: '',
		startValue: '',
		endValue: '',
		rate: '',
	}
}

function clearItemPromotion() {
	promotion_detail.value = {
		uid: '',
		groupUid: '',
		shopUid: '',
		promoName: '',
		cusTypeUid: '',
		description: '',
		startDate: new Date(),
		endDate: new Date(),
		tiers: [],
		intStatus: '',
		version: '',
	}

}


function addItemPromotion() {
	clearItemPromotion()
	title_promotion.value = t("content.addpromo")
	process_promotion.value = 'add'
	document.getElementById('newPromo').click()
}

function editItemPromotion(item) {
	clearItemPromotion()
	promotion_detail.value = {
		uid: item.uid,
		groupUid: item.groupUid,
		shopUid: item.shopUid,
		promoName: item.promoName,
		cusTypeUid: item.cusTypeUid,
		description: item.description,
		startDate: new Date(item.startDate),
		endDate: new Date(item.endDate),
		intStatus: item.intStatus,
		version: item.version,
		tiers: item.tiers,
	}
	promotion_detail.value = JSON.parse(JSON.stringify(item));
	title_promotion.value = t("content.editpromo")
	process_promotion.value = 'edit'
	document.getElementById('newPromo').click()
}

function chkProcessPromotion() {
	// ตรวจสอบข้อมูลใน Tiers ทั้งหมด
    const isValid = promotion_detail.value.tiers.every(group => {
        // เช็คเดือนต้อง >= 1
        if (group.month < 1 || !group.month) return false;
        // เช็คในแต่ละแถวของช่วงราคา
        return group.tiers.every(tier => {
            return tier.startValue >= 1 && tier.endValue >= 1 && tier.rate >= 0;
        });
    });

	if (!isValid) {
		swal("กรุณาระบุจำนวนเดือนและช่วงราคาให้ถูกต้อง (ขั้นต่ำคือ 1)", "", "error")
        return;
	} else {
		if (process_promotion.value === 'add') {
			addPromotion()
		} else if (process_promotion.value === 'edit') {
			editPromotion()
		}
	}
	
}

async function updateItemsInterest(item, val) {
	swal({
		title: "แก้ไขรายการ",
		text: "คุณต้องการแก้ไขรายการนี้ใช่ไหม",
		icon: "info",
		allowOutsideClick: false,
		showCloseButton: false,
		showCancelButton: true,
		closeOnConfirm: false,
		focusConfirm: false,
		animation: "slide-from-top",
		confirmButtonText: t('buttons.conf'),
		cancelButtonText: t('buttons.canc'),
	}).then((result) => {
		if (result.isConfirmed) {
			if (item.uid !== "") {
				updateInterest(item, val)
			}
		}
	})
}

async function updateItemsPromotion(item, val) {
	swal({
		title: "แก้ไขรายการ",
		text: "คุณต้องการแก้ไขรายการนี้ใช่ไหม",
		icon: "info",
		allowOutsideClick: false,
		showCloseButton: false,
		showCancelButton: true,
		closeOnConfirm: false,
		focusConfirm: false,
		animation: "slide-from-top",
		confirmButtonText: t('buttons.conf'),
		cancelButtonText: t('buttons.canc'),
	}).then((result) => {
		if (result.isConfirmed) {
			if (item.uid !== "") {
				updatePromotion(item, val)
			}
		}
	})
}

async function editRowItemsTiers(item) {
	swal({
		title: "แก้ไขรายการ",
		text: "คุณต้องการแก้ไขรายการนี้ใช่ไหม",
		icon: "info",
		allowOutsideClick: false,
		showCloseButton: false,
		showCancelButton: true,
		closeOnConfirm: false,
		focusConfirm: false,
		animation: "slide-from-top",
		confirmButtonText: t('buttons.conf'),
		cancelButtonText: t('buttons.canc'),
	}).then((result) => {
		if (result.isConfirmed) {
			cancelInterestTier()
			tier_detail.value = {
				uid: item.uid,
				startValue: item.startValue,
				endValue: item.endValue,
				rate: item.rate,
			}
		}
	})
}

async function deleteRowItemsTiers(item,row) {
	swal({
		title: "ลบรายการ",
		text: "คุณต้องการลบรายการนี้ใช่ไหม",
		icon: "warning",
		allowOutsideClick: false,
		showCloseButton: false,
		showCancelButton: true,
		closeOnConfirm: false,
		focusConfirm: false,
		animation: "slide-from-top",
		confirmButtonText: t("buttons.conf"),
		cancelButtonText: t("buttons.canc"),
	}).then((result) => {
		if (result.isConfirmed) {
			if (item.uid !== "") {
				deleteInterestTier(item,row)
			}
		}
	});
}

async function deleteRowInterestItems(item) {
	swal({
		title: "ลบรายการ",
		text: "คุณต้องการลบรายการนี้ใช่ไหม",
		icon: "warning",
		allowOutsideClick: false,
		showCloseButton: false,
		showCancelButton: true,
		closeOnConfirm: false,
		focusConfirm: false,
		animation: "slide-from-top",
		confirmButtonText: t("buttons.conf"),
		cancelButtonText: t("buttons.canc"),
	}).then((result) => {
		if (result.isConfirmed) {
			if (item.uid !== "") {
				deleteInterest(item.uid)
			}
		}
	});
}

async function deleteRowPromotionItems(item) {
	swal({
		title: "ลบรายการ",
		text: "คุณต้องการลบรายการนี้ใช่ไหม",
		icon: "warning",
		allowOutsideClick: false,
		showCloseButton: false,
		showCancelButton: true,
		closeOnConfirm: false,
		focusConfirm: false,
		animation: "slide-from-top",
		confirmButtonText: t("buttons.conf"),
		cancelButtonText: t("buttons.canc"),
	}).then((result) => {
		if (result.isConfirmed) {
			if (item.uid !== "") {
				deletePromotion(item.uid)
			}
		}
	});
}

function checkCustype(str) {
	let side = ''
	if (str !== '0') {
		let ld = listcustype.value.filter((c) => c.uid === str);
		if (ld.length > 0) {
			side = ld[0].name
		}
	}
	return side
}

function checkIntType(str) {
	let side = ''
	if (str !== '0') {
		let ld = forms.listType.filter((c) => c.val === str);
		if (ld.length > 0) {
			side = ld[0].items
		}
	}
	return side
}


async function addInterest() {
	const payload = interest_detail.value;
	payload.tiers = []
	payload.intName = payload.intName.trim()
	payload.groupUid = shop_detail.value.groupUid,
	payload.shopUid = shop_detail.value.uid
	payload.startDate = moment(new Date(payload.startDate)).local().format('YYYY-MM-DD')
	payload.endDate = moment(new Date(payload.endDate)).local().format('YYYY-MM-DD')
	// console.log("addInterest p : " + JSON.stringify(payload));
	const response = await storei.interestConfigAddFetch(payload);
	// console.log("addInterest r : " + JSON.stringify(response.data));
	if (response) {
		if (response.status === 200) {
			if (response.data.rtnDesc === "success") {
				swal("บันทึกสำเร็จ", "", "success");
				loadInterestListApi('add')
			} else {
				swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
			}
		}
	}
}

async function editInterest() {
	const payload = interest_detail.value;
	let tier = payload.tiers.filter(item => item.uid !== '0');
	payload.tiers = tier
	payload.tiers.forEach(item => {
		item.startValue = String(item.startValue)
		item.endValue = String(item.endValue)
		item.rate = String(item.rate)
		delete item.uid
	});
	payload.intName = payload.intName.trim()
	payload.startDate = moment(new Date(payload.startDate)).local().format('YYYY-MM-DD')
	payload.endDate = moment(new Date(payload.endDate)).local().format('YYYY-MM-DD')
	// console.log("editInterest p : " + JSON.stringify(payload));
	const response = await storei.interestConfigUpdateFetch(payload);
	// console.log("editInterest r : " + JSON.stringify(response.data));
	if (response) {
		if (response.status === 200) {
			if (response.data.rtnDesc === "success") {
				swal("บันทึกสำเร็จ", "", "success");
				loadInterestListApi('edit')
			} else {
				swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
			}
		}
	}


}

async function addPromotion() {
	// const payload = promotion_detail.value;
	const payload = {
        ...promotion_detail.value,
        tiers: promotion_detail.value.tiers.map(g => ({
            ...g,
            month: Number(g.month),
            tiers: g.tiers.map(t => ({
                ...t,
                startValue: Number(t.startValue),
                endValue: Number(t.endValue),
                rate: Number(t.rate)
            }))
        }))
    };
	payload.promoName = payload.promoName.trim()
	payload.groupUid = shop_detail.value.groupUid
	payload.shopUid = shop_detail.value.uid
	payload.startDate = moment(new Date(payload.startDate)).local().format('YYYY-MM-DD')
	payload.endDate = moment(new Date(payload.endDate)).local().format('YYYY-MM-DD')
	// console.log("addPromotion p : " + JSON.stringify(payload));
	const response = await storep.promotionConfigAddFetch(payload);
	// console.log("addPromotion r : " + JSON.stringify(response.data));
	if (response) {
		if (response.status === 200) {
			if (response.data.rtnDesc === "success") {
				await loadPromotionListApi('add')
				swal("บันทึกสำเร็จ", "", "success");
			} else {
				swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
			}
		}
	}
}


async function editPromotion() {
	const payload = {
        ...promotion_detail.value,
        tiers: promotion_detail.value.tiers.map(g => ({
            ...g,
            month: Number(g.month),
            tiers: g.tiers.map(t => ({
                ...t,
                startValue: Number(t.startValue),
                endValue: Number(t.endValue),
                rate: Number(t.rate)
            }))
        }))
    };
	payload.promoName = payload.promoName.trim()
	payload.startDate = moment(new Date(payload.startDate)).local().format('YYYY-MM-DD')
	payload.endDate = moment(new Date(payload.endDate)).local().format('YYYY-MM-DD')
	// console.log("editPromotion p : " + JSON.stringify(payload));
	const response = await storep.promotionConfigUpdateFetch(payload);
	// console.log("editPromotion r : " + JSON.stringify(payload));
	if (response) {
		if (response.status === 200) {
			if (response.data.rtnDesc === "success") {
				await loadPromotionListApi('edit')
				swal("บันทึกสำเร็จ", "", "success");

			} else {
				swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
			}
		}
	}
}

async function addInterestTier(item) {
	const payload = {
		uid: item.uid,
		groupUid : item.groupUid,
        shopUid: item.shopUid,
        intName: item.intName,
        description: item.description,
        intType: item.intType,
        defaultInt: item.defaultInt,
        startDate: item.startDate,
        endDate: item.endDate,
        tiers: item.tiers,
        intStatus: item.intStatus,
        version: item.version,
	};
	payload.tiers.forEach(item => {
		item.startValue = String(item.startValue)
		item.endValue = String(item.endValue)
		item.rate = String(item.rate)
		delete item.uid
	});
	// console.log("addInterestTier p : " + JSON.stringify(payload));
	const response = await storei.interestConfigUpdateFetch(payload);
	// console.log("addInterestTier r : " + JSON.stringify(response.data));
	if (response) {
		if (response.status === 200) {
			if (response.data.rtnDesc === "success") {
				swal("บันทึกสำเร็จ", "", "success");
				await loadInterestListApi('update')
			} else {
				swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
			}
		}
	}


}

async function updateInterest(item, val) {
	let data = "";
	data = {
		uid: item.uid,
	};
	let response = null
	const payload = data;
	// console.log("updateInterest v : " + val);
	if (val === 'terminate') {
		response = await storei.interestConfigTerminateFetch(payload);
	} else if (val === 'approve') {
		if (item.intStatus === 'DRAFT') {
			response = await storei.interestConfigApproveFetch(payload);
		} else if (item.intStatus === 'APPROVE') {
			response = await storei.interestConfigRevertFetch(payload);
		}

	}

	if (response) {
		if (response.status === 200) {
			// console.log("updateInterest r : " + JSON.stringify(response.data));
			if (response.data.rtnDesc === "success") {
				swal("บันทึกสำเร็จ", "", "success");
				loadInterestListApi('update')
			} else {
				swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
			}
		}
	}

}

async function updatePromotion(item, val) {
	let data = "";
	data = {
		uid: item.uid,
	};
	let response = null
	const payload = data;
	if (val === 'terminate') {
		response = await storep.promotionConfigTerminateFetch(payload);
	} else if (val === 'approve') {
		if (item.intStatus === 'DRAFT') {
			response = await storep.promotionConfigApproveFetch(payload);
		} else if (item.intStatus === 'APPROVE') {
			response = await storep.promotionConfigRevertFetch(payload);
		}

	}
	if (response) {
		if (response.status === 200) {
			// console.log("updatePromotion r : " + JSON.stringify(response.data));
			if (response.data.rtnDesc === "success") {
				swal("บันทึกสำเร็จ", "", "success");
				loadPromotionListApi('update')
			} else {
				swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
			}
		}
	}
}

async function updateInterestTier(item,row) {
	const payload = {
		uid: item.uid,
		groupUid : item.groupUid,
        shopUid: item.shopUid,
        intName: item.intName,
        description: item.description,
        intType: item.intType,
        defaultInt: item.defaultInt,
        startDate: item.startDate,
        endDate: item.endDate,
        tiers: item.tiers,
        intStatus: item.intStatus,
        version: item.version,
	};
	let tier = payload.tiers.filter(item => item.uid !== '0');
	const updatedList = tier.map(item => 
	item.uid === row.uid 
		? { ...item, startValue: tier_detail.value.startValue, endValue:  tier_detail.value.endValue , rate :  tier_detail.value.rate } // เจอแล้ว -> เปลี่ยนค่า
		: item                                         // ไม่ใช่ตัวที่หา -> ส่งกลับค่าเดิม
	);
	payload.tiers = updatedList
	payload.tiers.forEach(item => {
		item.startValue = String(item.startValue)
		item.endValue = String(item.endValue)
		item.rate = String(item.rate)
		delete item.uid
	});
	// console.log("updateInterestTier p : " + JSON.stringify(payload));
	const response = await storei.interestConfigUpdateFetch(payload);
	// console.log("updateInterestTier r : " + JSON.stringify(response.data));
	if (response) {
		if (response.status === 200) {
			if (response.data.rtnDesc === "success") {
				swal("บันทึกสำเร็จ", "", "success");
				cancelInterestTier()
				await loadInterestListApi('update')
			} else {
				swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
			}
		}
	}
}

async function deleteInterestTier(row,item) {
	const payload = {
		uid: item.uid,
		groupUid : item.groupUid,
        shopUid: item.shopUid,
        intName: item.intName,
        description: item.description,
        intType: item.intType,
        defaultInt: item.defaultInt,
        startDate: item.startDate,
        endDate: item.endDate,
        tiers: item.tiers,
        intStatus: item.intStatus,
        version: item.version,
	};
	let tier = payload.tiers.filter(item => item.uid !== '0' && item.uid !== row.uid);
	payload.tiers = tier
	payload.tiers.forEach(item => {
		item.startValue = String(item.startValue)
		item.endValue = String(item.endValue)
		item.rate = String(item.rate)
		delete item.uid
	});
	// const response = await store.dispatch("unitDeleteFetch", payload);
	// console.log("deleteInterestTier p : " + JSON.stringify(payload));
	const response = await storei.interestConfigUpdateFetch(payload);
	// console.log('deleteInterestTier r : '+JSON.stringify(response));
	if (response) {
		if (response.status === 200) {
			if (response.data.rtnDesc === "success") {
				swal("บันทึกสำเร็จ", "", "success");
				loadInterestListApi('update')
			} else {
				swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
			}
		}
	}

}

async function deleteInterest(id) {
	let data = "";
	data = {
		uid: id,
	};
	const payload = data;
	// const response = await store.dispatch("unitDeleteFetch", payload);
	const response = await storei.interestConfigDeleteFetch(payload);
	// console.log('loadDataApi : '+JSON.stringify(response));
	if (response) {
		if (response.status === 200) {
			if (response.data.rtnDesc === "success") {
				swal("บันทึกสำเร็จ", "", "success");
				loadInterestListApi('del')
			} else {
				swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
			}
		}
	}

}


async function deletePromotion(id) {
	let data = "";
	data = {
		uid: id,
	};
	const payload = data;
	// const response = await store.dispatch("unitDeleteFetch", payload);
	const response = await storep.promotionConfigDeleteFetch(payload)
	// console.log('loadDataApi : '+JSON.stringify(response));
	if (response) {
		if (response.status === 200) {
			if (response.data.rtnDesc === "success") {
				swal("บันทึกสำเร็จ", "", "success");
				loadPromotionListApi('del')
			} else {
				swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
			}
		}
	}

}

// --- Methods ---
const addTierGroup = () => {
    const nextOrdinal = promotion_detail.value.tiers.length + 1;
    promotion_detail.value.tiers.push({
        ordinal: nextOrdinal.toString(),
        month: "1",
        tiers: [{ startValue: 1, endValue: 999999999, rate: '' }]
    });
};

const removeTierGroup = (gIdx) => {
    promotion_detail.value.tiers.splice(gIdx, 1);
    // ทำการรันเลข ordinal ใหม่ให้ถูกต้อง
    promotion_detail.value.tiers.forEach((item, index) => {
        item.ordinal = (index + 1).toString();
    });
};

// --- ฟังก์ชันลบเฉพาะแถวสุดท้าย ---
const removeLastTierRow = (gIdx) => {
    const targetTiers = promotion_detail.value.tiers[gIdx].tiers;
    
    if (targetTiers.length > 1) {
        targetTiers.pop(); // ลบ Array ตัวสุดท้ายออก
	} else {
		swal("ไม่สามารถลบแถวสุดท้ายออกได้ ต้องมีอย่างน้อย 1 รายการ", "", "error");
    }
};

// --- ฟังก์ชันเพิ่มแถวใหม่ (แนะนำให้ใช้คู่กัน) ---
const addTierRow = (gIdx) => {
    const targetTiers = promotion_detail.value.tiers[gIdx].tiers;
    const lastRow = targetTiers[targetTiers.length - 1];

    // ตรวจสอบว่าใส่ค่า End Value ของแถวเดิมหรือยังก่อนเพิ่มแถวใหม่
    if (lastRow.endValue <= lastRow.startValue) {
		swal("กรุณาระบุราคาสิ้นสุด ให้ถูกต้องก่อนเพิ่มช่วงใหม่", "", "error");
        return;
    }

    targetTiers.push({
        startValue: lastRow.endValue + 1, // เริ่มต้นต่อจากค่าเดิมทันที
        endValue: 999999999,
        rate: ''
    });
};



onMounted(() => {
	if (document.getElementById("choices-month")) {
		var month = document.getElementById("choices-month");
		setTimeout(function () {
			new Choices(month);
		}, 1);

		// eslint-disable-next-line no-unused-vars
		var d = new Date();
		var monthArray = new Array();
		monthArray[0] = "January";
		monthArray[1] = "February";
		monthArray[2] = "March";
		monthArray[3] = "April";
		monthArray[4] = "May";
		monthArray[5] = "June";
		monthArray[6] = "July";
		monthArray[7] = "August";
		monthArray[8] = "September";
		monthArray[9] = "October";
		monthArray[10] = "November";
		monthArray[11] = "December";
		for (let m = 0; m <= 11; m++) {
			var optn = document.createElement("OPTION");
			optn.text = monthArray[m];
			// server side month start from one\
			optn.value = m + 1;
			// if june selected
			if (m == 1) {
				optn.selected = true;
			}
			month.options.add(optn);
		}
	}

	if (document.getElementById("choices-day")) {
		var day = document.getElementById("choices-day");
		setTimeout(function () {
			new Choices(day);
		}, 1);

		for (let y = 1; y <= 31; y++) {
			var optn1 = document.createElement("OPTION");
			optn1.text = y;
			optn1.value = y;

			if (y == 1) {
				optn1.selected = true;
			}

			day.options.add(optn1);
		}
	}

	if (document.getElementById("choices-year")) {
		var year = document.getElementById("choices-year");
		setTimeout(function () {
			new Choices(year);
		}, 1);

		for (let y = 1900; y <= 2020; y++) {
			var optn2 = document.createElement("OPTION");
			optn2.text = y;
			optn2.value = y;

			if (y == 2020) {
				optn.selected = true;
			}

			year.options.add(optn2);
		}
	}
});
</script>

<style lang="scss" scoped>
/* ตกแต่งตัวเลขลำดับกลุ่มย่อย */
.group-number {
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background-color: #388e3c; /* สีเขียวเดียวกับธีม */
  color: white;
  border-radius: 50%;
  font-size: 11px;
  margin-left: 10px; /* ขยับเข้ามาข้างในหน่อยเพื่อให้ดูเป็น sub-item */
}

/* ปรับให้แถว sub-row ดูดรอปลงมาจากแถวหลัก */
.sub-row td {
  border-bottom: 1px dashed #eee; /* เส้นประคั่นบางๆ */
  color: #777;
  font-size: 13px;
}

.highlight-rate {
  font-weight: bold;
  color: #2e7d32;
}
</style>